var NativeDateType;
(function (NativeDateType) {
    NativeDateType["DATE"] = "date";
    NativeDateType["DATETIME_LOCAL"] = "datetime-local";
    NativeDateType["MONTH"] = "month";
    NativeDateType["TIME"] = "time";
})(NativeDateType || (NativeDateType = {}));
export default NativeDateType;
//# sourceMappingURL=native-date-type.js.map